import React, { useState } from "react"
import { Box } from "@infotech/uikit-grid"
import DataGrid from "@infotech/uikit-datagrid"
import { SearchIcon } from "@infotech/uikit-icons"
import Input from "@infotech/uikit-input"
import classnames from "classnames"
import { connect } from "react-redux"
import { useQueryState } from "src/hooks"
import { wrappedDataGridStyle } from "src/components/DataGridContainer"
import useFilter from "src/components/EntityListEditor/hocs/useFilter"
import RolesModal from "src/components/RolesModal"
import { selectValue } from "src/engine/modules/ui/selectors"
import styles from "src/components/EntityListTable/styles.css"
import useRoleList from "./hooks/useRoleList"

const columns = [
  {
    Header: `Наименование роли`,
    accessor: `name`,
    maxWidth: 265,
    sortable: true,
  },
  {
    Header: `Описание роли`,
    accessor: `description`,
    sortable: true,
  },
]

const Roles = connect(state => ({
  areMenuCaptionsVisible: selectValue(state, `areMenuCaptionsVisible`),
}))(({ areMenuCaptionsVisible }) => {
  const {
    query,
    query: { page, pageSize, orderBy, filter },
    handlers: { setQuery },
  } = useQueryState()

  const { nameState, handleSearchInputChange } = useFilter({
    query,
    setQuery,
  })

  const {
    state: { list, count, pending },
  } = useRoleList({
    limit: pageSize,
    offset: pageSize * (page - 1),
    orderBy: orderBy
      ? `${orderBy[0].id} ${orderBy[0].desc ? `desc` : `asc`}`
      : undefined,
    query: filter || undefined,
  })

  const [modalData, setModalData] = useState(null)

  const modal = modalData && (
    <RolesModal
      onCancel={() => setModalData(null)}
      role={modalData.name}
      roleName={modalData.description}
    />
  )

  return (
    <Box>
      <Box h="67px" flex pl="2md" align="center">
        <Input
          style={{ width: 330 }}
          placeholder="Введите наименование роли для поиска"
          icon={SearchIcon}
          onChange={handleSearchInputChange}
          value={nameState}
        />
      </Box>
      <div data-testid="role-list-table">
        <DataGrid
          pending={pending}
          hideUselessPagination
          multiline
          showTextOverflowHintOn="hover"
          totalCount={count}
          withBorder
          pageSize={pageSize}
          className={classnames(wrappedDataGridStyle, {
            [[styles.narrowSidebar]]: !areMenuCaptionsVisible,
            [[styles.wideSidebar]]: areMenuCaptionsVisible,
          })}
          showPageSizeOptions
          onPageSizeChange={pageSize => setQuery({ pageSize, page: 1 })}
          onSortedChange={orderBy => {
            setQuery({
              orderBy: orderBy.length > 0 ? orderBy : undefined,
              page: 1,
            })
          }}
          sorted={orderBy || []}
          manual
          data={list}
          columns={columns}
          page={page - 1 || 0}
          onPageChange={page => {
            setQuery({ page: page + 1 })
          }}
          getTrProps={(_, rowInfo) => ({
            onClick: () => setModalData(rowInfo.original),
          })}
          withSidesBorder
        />
      </div>
      {modal}
    </Box>
  )
})

export default Roles
